import { CHANNELS, type ReleaseChannel } from '@/lib/db';

export function channelI18nKey(
  channel: ReleaseChannel,
): 'channel.beta' | 'channel.stable' {
  return channel === CHANNELS.beta ? 'channel.beta' : 'channel.stable';
}
